import React from "react";
import "./roi.css";
import useIntersectionObserver from "../customHooks/useIntersectionObserver";
import NumberDisplay from "../NumberDisplay";
export default function ROI() {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.25 });
  const roiContent = [
    {
      heading: "Time Reduction",
      first: 55,
      last: 80,
      char: "%",
    },
    {
      heading: "Accuracy",
      first: 65,
      last: 90,
      char: "%",
    },
    {
      heading: "Cost Savings",
      first: 25,
      last: 50,
      char: "%",
    },
    {
      heading: "Faster Deployment",
      first: 0,
      last: 3,
      char: "x",
    },
  ];

  return (
    <section
      className={`roi-section ${isVisible ? "section-animation" : ""}`}
      ref={ref}
      id="three"
    >
      <div className="container">
        <div className="section-wrapper roi-section-wrapper">
          <div className="section-heading">
            <div className="heading-tag">
              <span>ROI</span>
            </div>
            <div className="heading-description">
              <h2>Unlock Efficiency and Maximize Value</h2>
              <p>Reduce Manual Effort, Cut Costs, and Accelerate Performance</p>
            </div>
          </div>
        </div>
        <div className="roi-content-wrapper">
          <div className="roi-stats-cards">
            {roiContent.map((item, index) => (
              <React.Fragment key={index}>
                <div className="roi-card" key={index}>
                  <NumberDisplay
                    first={item.first}
                    last={item.last}
                    char={item.char}
                    isVisible={isVisible}
                  />
                  <h3>{item.heading}</h3>
                </div>
                {index !== 3 && <div className="divider"></div>}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
